import { ArrowUpRight, Gem, MessageSquareQuote, Phone, Sparkles } from "lucide-react";
import { Panel } from "./Fields";

const Stat = ({ icon: Icon, label, value, sub, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className="group text-left rounded-2xl border border-white/[0.08] bg-white/[0.03] p-5 hover:border-[#8a8dff]/50 hover:bg-white/[0.05] transition-colors">
    <div className="flex items-center justify-between">
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#5b5fd6]/20 text-[#a4a6ff] group-hover:bg-[#5b5fd6] group-hover:text-white transition-colors"><Icon size={18} /></span>
      <ArrowUpRight size={16} className="text-[#a4a6ff] transition-transform group-hover:rotate-45" />
    </div>
    <p className="mt-5 text-xs uppercase tracking-[0.14em] text-[#c9c6f0]">{label}</p>
    <p className="mt-1 font-display text-2xl font-bold truncate">{value}</p>
    {sub && <p className="mt-1 text-xs text-[#a4a6ff] truncate">{sub}</p>}
  </button>
);

export const Overview = ({ data, go }) => {
  const pk = Array.isArray(data?.packages) ? data.packages : [];
  const rv = Array.isArray(data?.reviews) ? data.reviews : [];
  const paid = pk.filter((p) => !p.trial);
  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Stat icon={Gem} label="Paketler" value={pk.length} sub={`${paid.length} ücretli · ${pk.length - paid.length} test`} onClick={() => go("packages")} testid="admin-stat-packages" />
        <Stat icon={Phone} label="WhatsApp hattı" value={data?.contact?.whatsappDisplay || "-"} sub="Sipariş ve destek numarası" onClick={() => go("contact")} testid="admin-stat-contact" />
        <Stat icon={MessageSquareQuote} label="Yorumlar" value={rv.length} sub="Sitede görünen" onClick={() => go("reviews")} testid="admin-stat-reviews" />
      </div>
      <Panel>
        <div className="flex items-center justify-between">
          <h2 className="font-display text-lg font-bold">Güncel fiyatlar</h2>
          <button onClick={() => go("packages")} className="text-sm text-[#a4a6ff] hover:text-white" data-testid="admin-overview-edit-prices">Düzenle</button>
        </div>
        <div className="mt-5 divide-y divide-white/[0.06]">
          {pk.map((p) => (
            <div key={p.id} className="flex items-center justify-between gap-4 py-3.5">
              <div className="flex items-center gap-3 min-w-0">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-white/[0.05] text-[#a4a6ff]">{p.trial ? <Sparkles size={15} /> : <Gem size={15} />}</span>
                <div className="min-w-0">
                  <p className="font-medium truncate">{p.name}</p>
                  <p className="text-xs text-[#a4a6ff] truncate">{p.period}{p.coverage ? ` · ${p.coverage}` : ""}</p>
                </div>
              </div>
              <span className="shrink-0 rounded-lg bg-[#5b5fd6]/15 px-3 py-1.5 font-display font-bold text-white">{p.price} {p.unit}</span>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
};
